import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as transactionsMainReducer from '../employee-detail.reducer';
import * as fromFilteredTransactions from '../reducers/filtered-transactions.reducer';


export const selectFilteredTransactions = createSelector(
    transactionsMainReducer.getFilteredTransactionsState,
    fromFilteredTransactions.getFilteredTransactions
  );